import entityMetaStore from "data/meta/entityMetaStore";

export default function getMapToTypes(activeRecordKey, stereotypes, doMapToKey) {
    const targets = {};
    const targatableStereotypes = stereotypes.filter(stereotype => {
        if (stereotype.magicRoot) return false;
        if (!stereotype.magicRootKey) return false;
        let found = false;
        stereotype.creatables.forEach(creatable => {
            creatable.versions.forEach(version =>
                found = found || version.key === activeRecordKey
            );
        });
        return found;
    });
    targatableStereotypes.forEach(stereotype => {
        stereotype.creatables.forEach(creatable => {
            const dk = creatable.defaultKey;
            creatable.versions.forEach(version => {
                const k = version.key;
                if (k === dk || ! dk) {
                    targets[k] = dk
                        ? `Map To New ${creatable.label} ${targatableStereotypes[0].name}`
                        : `Map To New ${creatable.label} ${version.label} ${targatableStereotypes[0].name}`;
                }
            });
        });
    });
    return entityMetaStore
        .getAllInfos(info => {
            if (!info.canCreate) return false;
            if (!targets.hasOwnProperty(info.key)) return false;
            if (info.mappingSources == null) return false;
            const crs = info.mappingSources.find(s =>
                s.pluginKey === "cross-record");
            if (crs == null) return false;
            if (crs.types.indexOf(activeRecordKey) < 0) return false;
            return true;
        })
        .map(info => ({
            label: targets[info.key],
            id: "new-" + info.key,
            type: "map-to-new",
            key: info.key,
            onClick: () => doMapToKey(info.key),
        }));
}



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/views/getMapToTypes.js